




































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import BaseMap from "@/components/BaseMap.vue";
import Formulario from "@/components/Formulario.vue";
import Promotion from "@/components/Promotion.vue";
import info from "@/info";

@Component({
  components: {
    Formulario,
    Navbar,
    Footer,
    BaseMap,
  },
})
export default class PrebaDeManejo extends Vue {
  private carsInfo: Array<object> = [];

  mounted() {
    this.carsInfo = info.home.headerSlider;
  }
}
